const isUrlBase64 = (url: string) => url.startsWith('data:audio/') && url.includes(';base64,')

export default isUrlBase64
